import { useState, useEffect } from 'react';
import { usersApi } from '../lib/api';

const TIER_ORDER: Record<string, number> = { R: 0, D: 1, C: 2, B: 3, A: 4, S: 5 };
const TIER_STORAGE_KEY = (userId: string, gameId?: string) =>
  `emss_last_tier_${userId}${gameId ? `_${gameId}` : ''}`;

export function useTierPromotion(emssUser: any, gameId?: string) {
  const [promotionData, setPromotionData] = useState<{
    newTier: string;
    prevTier: string;
  } | null>(null);

  useEffect(() => {
    if (!emssUser?.id) return;

    let isMounted = true;

    const checkTierPromotion = async () => {
      try {
        const stats = (await usersApi.stats(gameId)) as any;
        const newTier: string = stats?.current_tier ?? 'R';
        const storageKey = TIER_STORAGE_KEY(emssUser.id, gameId);
        const lastTier = localStorage.getItem(storageKey);

        if (lastTier === null) {
          // Primeira execução no navegador/dispositivo: salva o tier atual sem exibir popup
          localStorage.setItem(storageKey, newTier);
          return;
        }

        if (
          lastTier !== newTier &&
          TIER_ORDER[newTier] !== undefined &&
          TIER_ORDER[lastTier] !== undefined
        ) {
          // Atualização de carteira (subida ou regresso)
          if (isMounted) {
            setPromotionData({ newTier, prevTier: lastTier });
          }
          // Persiste imediatamente o novo tier para não repetir o aviso nos próximos acessos
          localStorage.setItem(storageKey, newTier);
        }
      } catch {
        // Silenciosamente ignora falhas não críticas ao buscar estatísticas
      }
    };

    checkTierPromotion();

    return () => {
      isMounted = false;
    };
  }, [emssUser?.id, gameId]);

  const clearPromotion = () => setPromotionData(null);

  return { promotionData, clearPromotion };
}

